import React from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateRangeFormat } from "../../../../Helpers/dateFormat";
import { useReadyReportStore } from "../../../../Store/ReportsStore/ReadyReportStore";

const DateSection = () => {
  const {
    queryParams,
    updateParams,
    startDate,
    endDate,
    loadItems,
    setLoading,
  } = useReadyReportStore();

  const dateHandler = useCallback(
    async (date) => {
      updateParams({ start_date: dateRangeFormat(date[0]) });
      updateParams({ end_date: dateRangeFormat(date[1]) });
      useReadyReportStore.setState({
        startDate: date[0],
        endDate: date[1],
      });
      if ((date[0] && date[1]) || (!date[0] && !date[1])) {
        setLoading(true);
        await loadItems(
          new URLSearchParams({
            ...queryParams,
            start_date: dateRangeFormat(date[0]) ?? "",
            end_date: dateRangeFormat(date[1]) ?? "",
          }).toString()
        );
        setLoading(false);
      }
    },
    [queryParams]
  );

  return (
    <DatePicker
      isClearable
      clearButtonClassName="date_clear-btn"
      className="payment-datepicker"
      placeholderText="mm/dd/yy - mm/dd/yy"
      selectsRange={true}
      startDate={startDate || null}
      endDate={endDate || null}
      onChange={(date) => dateHandler(date)}
    />
  );
};
export default React.memo(DateSection);
